import { render, staticRenderFns } from "./EmpresaContribuyenteCreate.vue?vue&type=template&id=40d3b93d&scoped=true&"
import script from "./EmpresaContribuyenteCreate.vue?vue&type=script&lang=js&"
export * from "./EmpresaContribuyenteCreate.vue?vue&type=script&lang=js&"
import style0 from "./EmpresaContribuyenteCreate.vue?vue&type=style&index=0&id=40d3b93d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d3b93d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VCol,VContainer,VFileInput,VForm,VIcon,VRow,VSwitch,VTextField})
